import React, { useEffect, useState } from "react";
import { api, errMsg } from "../../lib/api";
import { Badge } from "./Fields";
import { KeyRound, Copy, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function TeamAccess() {
  const [team, setTeam] = useState([]);
  const [link, setLink] = useState(null);

  const load = () => api.get("/admin/team").then(r => setTeam(r.data));
  useEffect(() => { load(); }, []);

  const generate = async (u) => {
    try {
      const r = await api.post(`/admin/team/${u.id}/password-link`);
      setLink({ ...r.data, email: u.email });
      toast.success(`${r.data.purpose === "setup" ? "Setup" : "Reset"} link created`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const copy = () => { navigator.clipboard.writeText(link.link); toast.success("Link copied — share it privately"); };

  return (
    <div className="space-y-4" data-testid="team-access">
      <div className="ae-card p-5 flex items-start gap-3">
        <ShieldCheck className="w-5 h-5 text-[#C5A059] mt-0.5" />
        <div className="text-sm text-slate-600">Admin and recruiter accounts can't be created through public sign-up. Passwords are set by each member through a one-time link (valid 60 min, single use) and stored only as secure hashes.</div>
      </div>
      {link && (
        <div className="ae-card p-5 border-2 border-[#C5A059]/40" data-testid="team-link-box">
          <div className="text-xs uppercase tracking-wider font-semibold text-slate-500 mb-2">One-time {link.purpose} link for {link.email}</div>
          <div className="flex gap-2">
            <input readOnly value={link.link} data-testid="team-link-value" className="flex-1 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-mono" />
            <button onClick={copy} data-testid="team-link-copy" className="ae-btn-primary text-xs inline-flex items-center gap-1.5"><Copy className="w-3 h-3" /> Copy</button>
          </div>
          <p className="text-[11px] text-slate-400 mt-2">We also tried emailing it. Generating a new link invalidates this one.</p>
        </div>
      )}
      <div className="ae-card divide-y divide-slate-100">
        {team.map(u => (
          <div key={u.id} className="p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`team-row-${u.id}`}>
            <div>
              <div className="font-medium text-[#0F2A4A]">{u.full_name} <span className="text-xs text-slate-400 font-normal">· {u.email}</span></div>
              <div className="flex flex-wrap gap-1.5 mt-1">
                <Badge cls="bg-[#0F2A4A] text-white">{u.role}</Badge>
                {u.password_set ? <Badge cls="bg-emerald-100 text-emerald-700">Password set</Badge> : <Badge cls="bg-amber-100 text-amber-700" tid={`team-pending-${u.id}`}>Setup pending</Badge>}
                {u.auth_provider === "google" && <Badge cls="bg-blue-100 text-blue-700">Google sign-in</Badge>}
                {u.is_demo && <Badge cls="bg-slate-200 text-slate-600">Demo · preview only</Badge>}
              </div>
            </div>
            {!u.is_demo && (
              <button onClick={() => generate(u)} data-testid={`team-link-btn-${u.id}`}
                className="text-xs px-3 py-1.5 rounded-lg border border-slate-200 hover:border-[#C5A059] inline-flex items-center gap-1.5 transition-colors">
                <KeyRound className="w-3 h-3" /> {u.password_set ? "Generate reset link" : "Generate setup link"}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
